export default __webpack_public_path__ + "assets/insets3.png";